import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import "./PricingSection.scss";

function PricingSection(props) {
  const plans = [
    {
      id: "licenses",
      image: "/licenses_logo.svg",
      name: "For creators",
      perks: [
        "Register and copyright your work as legally protected IP",
        "Support for any file type (video, audio, images, PDF, text, code, etc.)",
        "List your work for sale or licensing",
        "Set your own price and terms to make license deals with brands using the Campaign app.",
       "Sell or license your work",
        "Receive automatic royalties for usage by licensees",
        "White-label-ready UI"
      ],
    },
    {
      id: "campaign",
      image: "/campaign_logo.svg",
      name: "For brands",
      perks: [
        "License work from content creators (IP owners) in the Licenses app",
        "Register and copyright proprietary content and corporate/brand assets",
        "Mint tradable token licenses that grant access to single IP assets or asset collections",
        "Distribute tokens and track redemption/usage/trading",
        "Settle royalty payments automatically",
        "White-label-ready UI"
      ],
    },
    {
      id: "portfolio",
      image: "/portfolio_logo.svg",
      name: "For consumers",
      perks: [
        "Acquire/collect tokens from brands and distributors in Campaign app",
        "Use tokens to access content",
        "Access token collection and usage history",
        "Fully customizable UI"
      ],
    },
  ];

  return (
    <Section
      id="pricing"
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
      <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={3}
          spaced={true}
          className="has-text-centered"
        />
        <div className="columns is-centered is-variable is-4 is-desktop">
          {plans.map((plan, index) => (
            <div
              className="PricingSection__column column is-one-third-desktop"
              key={index}
            >
              <div className="PricingSection__card card">
                <div className="PricingSection__card-content card-content">
                  <div className="PricingSection__image-container image">
                    <img className="PricingSection__image"
                      src={plan.image} alt="Logo" 
                    />
                  </div>
                  <br />
                  <div className="PricingSection__name has-text-weight-bold">
                    {plan.name}
                  </div>

                  {plan.description && (
                    <p className="PricingSection__description">
                      {plan.description}
                    </p>
                  )}

                  {plan.perks && (
                    <ul className="PricingSection__perks">
                      {plan.perks.map((perk, index) => (
                        <li key={index}>
                          <i className="fas fa-check has-text-primary" />
                          {perk}
                        </li>
                      ))}
                    </ul>
                  )}
                  <a
                    className="PricingSection__button button is-large is-primary"
                    href={`https://${plan.id}-beta.pdsapps.io/`}
                  >
                    Check it out
                  </a>
                </div>
                {index !== plans.length - 1 && (
                  <i className="fas fa-long-arrow-alt-right is-large is-primary PricingSection__arrow" style={{fontSize: 40, position: "absolute", top: "50%", right: "-20px", transform: "translateY(-50%)"}} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
}

export default PricingSection;
